<template>
  <div>
    <AdSense />
    <section class="hero">
      <div class="hero-content">
        <img src="../assets/icon.jpg" alt="Gogo Saporu" class="bot-icon" />
        <h1>Gogo Saporu</h1>
        <p>El mejor bot de todo Discord</p>
      </div>
    </section>

    <div class="page-container">
      <h2>¿Qué es Gogo?</h2>
      <p>Gogo Saporu es la deidad definitiva, disponible en Discord y, a futuro, en WhatsApp y Telegram (atentos a 2026 c;). Lo que comenzó como un simple bot ha evolucionado hasta convertirse en un ecosistema completo que incluye esta página web y una app (sin implementar).</p>
      <img src="../assets/gogonator.jpg" alt="Gogonator" class="feature-image" />
    </div>

    <div class="page-container">
      <h2>El Bot de Discord</h2>
      <p>Gogo ofrece una amplia variedad de funcionalidades para satisfacernos a nosotros, mortales:</p>
      <ul>
        <li><strong>Sistema de GogoPoints:</strong> La única moneda aceptada en el Gogoverso</li>
        <li><strong>Gogo Hípica:</strong> Carreras de caballos virtuales con apuestas</li>
        <li><strong>Blackjack:</strong> Juego de cartas contra el crupier o entre usuarios</li>
        <li><strong>Y mucho más...</strong></li>
      </ul>
      <img src="../assets/crupier.jpg" alt="Gogo Crupier" class="feature-image" />
    </div>

    <div class="page-container">
      <h2>La Página Web</h2>
      <p>Esta página web informa a todo creyente sobre el Gogoverso, además de:</p>
      <ul>
        <li>Documentar funcionalidades de Gogo</li>
        <li>Permitir a los gogoamigos hablar entre ellos y compartir su sabiduría sobre la divinidad</li>
        <li>Crear una comunidad más allá de Discord, internet y el cosmos</li>
      </ul>
      <img src="../assets/gogoranger.jpg" alt="Gogo Ranger" class="feature-image" />
    </div>

    <div class="page-container">
      <h2>Características del Proyecto</h2>
      <p>El proyecto Gogo Saporu se caracteriza por:</p>
      <ul>
        <li><strong>Gratuito:</strong> Sin costes ni transacciones de divisas diferentes a los gogopoints</li>
        <li><strong>Comunidad:</strong> Fomenta la interacción entre creyentes y el respeto a todo lo que no es Humori</li>
        <li><strong>Personalidad única:</strong> Gogo tiene su propio carácter y estilo</li>
        <li><strong>Desarrollo continuo:</strong> Siempre añadiendo nuevas funcionalidades</li>
      </ul>
    <img src="../assets/19_sin_titulo_20240129021131.png" alt="Gogo Power" class="feature-image" />
    </div>

    <div class="page-container">
      <h2>Cómo Empezar</h2>
      <p>Para disfrutar de la experiencia completa de Gogo Saporu:</p>
      <ol>
        <li>Invita a Gogo a tu servidor de Discord</li>
        <li>Explora los comandos disponibles (te buscas la vida, no hay comando de ayuda)</li>
        <li>Regístrate en esta página web para acceder a funcionalidades adicionales</li>
        <li>Únete a la comunidad y comparte tu experiencia</li>
        <li>¡Disfruta de los juegos y gana GogoPoints!</li>
      </ol>
      <img src="../assets/andersen.jpg" alt="Amen" class="feature-image" />
    </div>

    <div class="page-container">
      <h2>El Futuro del Proyecto</h2>
      <p>Gogo Saporu sigue creciendo. Nuestros planes incluyen:</p>
      <ul>
        <li>Más juegos y funcionalidades para el bot</li>
        <li>Mejoras continuas en la página web</li>
        <li>Una futura aplicación móvil</li>
        <li>Nuevas formas de interacción entre Discord y la web</li>
      </ul>
      <p><em>¡El viaje de Gogo apenas está comenzando!</em></p>
      <img src="../assets/gogostore.jpg" alt="Gogo Store" class="feature-image" />
    </div>
  </div>
  <AdSense />
  <AdSense />
  <AdSense />
  <AdSense />
  <AdSense />
  <AdSense />
</template>

<script>
import AdSense from './AdSense.vue';

export default {
  name: "AppProject",
  components: {
    AdSense
  }
};
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 4rem 0;
  text-align: center;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.bot-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-bottom: 2rem;
}

h1 {
  color: white;
  font-size: 3rem;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

h2 {
  color: white;
  font-size: 2rem;
  margin-bottom: 1rem;
}

p {
  color: white;
  line-height: 1.6;
  margin-bottom: 1rem;
}

ul, ol {
  color: white;
  line-height: 1.6;
  margin-bottom: 1rem;
}

li {
  margin-bottom: 0.5rem;
}

.feature-image {
  width: 100%;
  max-width: 800px;
  border-radius: 8px;
  margin: 2rem auto;
  display: block;
}

.page-container {
  margin: 0 auto;
  padding: 2rem;
}

code {
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  font-family: 'Courier New', monospace;
  color: #00ffff;
  font-weight: bold;
}

strong {
  color: #ffd700;
}
</style>
